export const PostTypeReel = 'reels';
export const PostTypePost = 'post';
export const PostTypeStory = 'story';
export const PostTypeShort = 'short';
export const PostTypeVideo = 'video';
